var _path, _line, _path2, _path3, _path4, _path5, _path6, _circle;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnBtnTalkPreviewHasLeftBorder = function SvgIcnBtnTalkPreviewHasLeftBorder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H18C19.1046 0 20 0.895431 20 2V18C20 19.1046 19.1046 20 18 20H0V0Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 4.5,
    x2: 0.499999,
    y2: 15.5,
    stroke: "#DDDEE1",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8V7C5 5.89543 5.89543 5 7 5H8",
    stroke: "#57595E",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12V13C5 14.1046 5.89543 15 7 15H8",
    stroke: "#57595E",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8V7C15 5.89543 14.1046 5 13 5H12",
    stroke: "#57595E",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12V13C15 14.1046 14.1046 15 13 15H12",
    stroke: "#57595E",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6847 10.3707C13.0442 10.8453 12.9753 11.5144 12.5836 11.9628C12.0205 12.6073 11.1925 13.0144 10.2695 13.0144H9.72544C8.80785 13.0144 7.98422 12.6121 7.42136 11.9742C7.02914 11.5297 6.95521 10.8643 7.30881 10.3885C7.35517 10.3261 7.4049 10.2655 7.45779 10.2067C7.90619 9.70889 8.66703 9.87973 9.31665 10.0437C9.53315 10.0984 9.76386 10.1279 10.0033 10.1279C10.2427 10.1279 10.4735 10.0984 10.69 10.0437C11.3396 9.87967 12.1005 9.70879 12.5489 10.2066C12.5968 10.2598 12.6421 10.3145 12.6847 10.3707Z",
    fill: "#57595E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.0047,
    cy: 8.19907,
    r: 1.2147,
    fill: "#57595E"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnBtnTalkPreviewHasLeftBorder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_btn_talk_preview_has_left_border.ceb47a20.svg";
export { ForwardRef as ReactComponent };